<template>
  <v-btn color="primary" @click="createOnamaeSession">
    最新の会員情報を同期する
  </v-btn>
</template>

<script>
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'

export default {
  name: 'SyncButtonContainer',
  methods: {
    createOnamaeSession () {
      if (!confirm('現在の会員情報を同期してもよろしいでしょうか？')) return
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .post('/api/onamae_mm_sessions')
        .then(({ data }) => {
          const payload = {
            status: 200,
            message: '同期を開始しました。'
          }
          this.$emit('create-session', deserialize(data).data)
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .catch((error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    }
  }
}
</script>
